import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fileUrl = (docId) => `${API}/documents/${docId}/download`;

export const CLIENT_NAME = "Harrods";

export const PROJECT_STATUSES = ["Not Started", "In-Progress", "On Hold", "Completed", "Canceled"];
export const TASK_STATUSES = ["Not Started", "In-Progress", "Issue", "Completed", "Canceled"];
export const PRIORITIES = ["High", "Medium", "Low"];
export const PHASES = ["Planning", "Development", "Contract Agreement", "Implementation", "Recruitment"];
export const DOC_CATEGORIES = ["Requirements", "Budget", "Graphic", "SOW", "FAQ", "Other"];

export const STATUS_STYLE = {
  "Not Started": { bg: "#f1f5f9", fg: "#475569", dot: "#94a3b8" },
  "In-Progress": { bg: "#eff6ff", fg: "#1d4ed8", dot: "#3b82f6" },
  Issue: { bg: "#fef2f2", fg: "#b91c1c", dot: "#ef4444" },
  Completed: { bg: "#ecfdf5", fg: "#047857", dot: "#10b981" },
  Canceled: { bg: "#f8fafc", fg: "#94a3b8", dot: "#cbd5e1" },
  "On Hold": { bg: "#fffbeb", fg: "#b45309", dot: "#f59e0b" },
};

export const PRIORITY_STYLE = {
  High: { bg: "#fef2f2", fg: "#b91c1c" },
  Medium: { bg: "#fffbeb", fg: "#b45309" },
  Low: { bg: "#f1f5f9", fg: "#475569" },
};

export const HEALTH_STYLE = {
  "On Track": { bg: "#ecfdf5", fg: "#047857" },
  "At Risk": { bg: "#fffbeb", fg: "#b45309" },
  Overdue: { bg: "#fef2f2", fg: "#b91c1c" },
  Completed: { bg: "#ecfdf5", fg: "#047857" },
};

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const fmtDate = (s) => {
  if (!s) return "–";
  const [y, m, d] = s.slice(0, 10).split("-");
  if (!y || !m || !d) return s;
  return `${d} ${MONTHS[parseInt(m, 10) - 1]} ${y}`;
};
export const fmtTs = (s) => {
  if (!s) return "";
  const d = new Date(s);
  return d.toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
};
export const timeAgo = (s) => {
  const diff = (Date.now() - new Date(s).getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
};
export const todayISO = () => new Date().toISOString().slice(0, 10);
